import axios from "axios"
import { useSnackbar } from "notistack";
import QueryString from "qs";
import { get } from "idb-keyval"
import { matchPath } from "react-router-dom";
import { useRecoilState } from "recoil";
import { errorStackState } from "pages/CustomerBooking";
import { serializeError } from "serialize-error";

const API_URL = process.env.REACT_APP_WEB_ADMIN_URL

const Interceptor = ({ quiet = false }) => {
  const { enqueueSnackbar } = useSnackbar()

  const [errorState, setErrorState] = useRecoilState(errorStackState);

  axios.interceptors.request.use(
    async (request) => {
      if (!["/providers/login"].some((r) => request.url.includes(r))) {
        const user = JSON.parse(localStorage.getItem("user"))
        request.headers["X-Auth-Token"] = user?.token ?? ""
      } else {
        // request.headers["Access-Control-Allow-Origin"] = "*"
      }
      request.paramsSerializer = (params) => {
        return QueryString.stringify(params, { arrayFormat: "repeat" });
      };

      if (!["chat/in_app/messages"].some((r) => request.url.includes(r))) {
        if (request.method === 'get') {
          request.params = {
            ...request.params,
            device_type: 'WEB'
          }
        } else {
          request.data = {
            ...request.data,
            device_type: 'WEB'
          }
        }
      }

      return request
    },
    (error) => {
      if (!quiet) {
        enqueueSnackbar(error.response?.data, { variant: "error" })
        const message = error?.message?.en || error?.response?.data?.message?.en || error?.response?.data?.details
        setErrorState([...errorState, { type: "Server Error", message, error: serializeError(error) }])
      }
      Promise.reject(error)
    }
  )
  // axios.interceptors.response.use(response => response, (error) => {
  //   const checkSafeFailUrl = [
  //     "/api/1/clients/:id/bookings/scheduled/verify",
  //   ].some((r) => {
  //     const requrl = error?.request?.responseURL
  //     const matchUrl = matchPath(requrl, {
  //       path: API_URL + r,
  //       exact: true,
  //       strict: false
  //     })
  //     return !!matchUrl && error?.response?.data?.code==='APPOINTMENT_ONGOING';
  //   })
  //   if (checkSafeFailUrl) {
  //     return error
  //   }

  //   enqueueSnackbar(error?.response?.data?.message?.en ?? error.message, { variant: "error" })
  //   Promise.reject(error)
  // })
  return null
}

export { Interceptor }
